
import { TranslatedStyledProperty } from "@/utils/documents/translated-styled-property";
import Vue from "vue";
export default Vue.extend({
	props: {
		lang: String,
		lines: Object as () => TranslatedStyledProperty
	}
});
